var MpMobileMenu;

(function() {
    'use strict';
    if (!document.querySelector('#vue-mobile-nav')) {
        return;
    }

    MpMobileMenu = new Vue({
        el: '#vue-mobile-nav',
        data: function() {
            return {
                ACTIVATION_CLASSNAME: 'mobile-nav__submenu--visible',
                DELAY_GAP: 200,

                allinWrapper: null,
                navigation: null,
                navPath: [],
                isOpen: false,

                initialized: false,
            };
        },
        computed: {},
        methods: {
            onClose: function() {
                var _this = this;

                noScroll.off();
                this.allinWrapper.classList.remove('mod-mobile-menu-is-open');
                setTimeout(function(){ _this.isOpen = false; }, 400);
            },

            onOpen: function() {
                noScroll.on();
                this.isOpen = true;
                this.allinWrapper.classList.add('mod-mobile-menu-is-open');
            },

            initNavigation: function() {
                this.navigation = this.$el.querySelectorAll('a[data-tree]') || {};
            },

            deactivateOption: function(optEl, activationClassName) {
                document.getElementById(optEl).classList.remove(activationClassName);
            },

            backToOption: function(ev) {
                var _this = this;

                var dest = ev.currentTarget.getAttribute('data-back'),
                    levelIndex = this.navPath.indexOf(dest),
                    delay = 0,
                    i;

                for (i=this.navPath.length; i>levelIndex; i--) {
                    setTimeout(this.deactivateOption, delay,_this.navPath.pop(), _this.ACTIVATION_CLASSNAME);
                    delay += this.DELAY_GAP;
                }
            },

            showOption: function(ev) {
                var option = ev.currentTarget.getAttribute('data-tree');

                this.navPath.push(option);
                document.getElementById(option).classList.add(this.ACTIVATION_CLASSNAME);
            },

            init: function() {
                this.allinWrapper = document.querySelector('body');
                this.initNavigation();

                MpEventBus.$on('openMenu', this.onOpen);
                MpEventBus.$on('closeMenu', this.onClose);
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();
